// externals
import { RSAA } from 'redux-api-middleware';

// libraries
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';

// consts/enums
import {
    OPEN_REPAIR_ORDERS_FETCH_REQUEST,
    OPEN_REPAIR_ORDERS_FETCH_SUCCESS,
    OPEN_REPAIR_ORDERS_FETCH_FAILURE
} from '../actionTypes/openRepairOrdersActionTypes';

// utils
import type { BffApiUrlResult } from '@makemydeal/dr-shared-ui-utils';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

export const fetchOpenRepairOrders = (vin: string): RSAACallAction => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult: BffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '');

    // The vin the response resolves, carried on every lifecycle action so the reducer knows which
    // cache entry it answers. Keep it a plain object: a function here would defer the request action
    // behind an await, and the per-vin dedupe in openRepairOrdersMiddleware depends on it landing
    // synchronously.
    const meta = { vin };

    const request: RSAACallRequest = {
        endpoint: `${bffApiUrlResult.url}/v1/repair-orders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vin }),
        types: [
            { type: OPEN_REPAIR_ORDERS_FETCH_REQUEST, meta },
            { type: OPEN_REPAIR_ORDERS_FETCH_SUCCESS, meta },
            { type: OPEN_REPAIR_ORDERS_FETCH_FAILURE, meta }
        ]
    };

    return { [RSAA]: request };
};
